import {useMutation} from '@apollo/react-hooks';

import type {
    connectedFormUnignore as ConnectedFormUnignoreMutation,
    connectedFormUnignoreVariables as ConnectedFormUnignoreMutationVariables,
    ConnectedFormUnignoreInput,
} from 'nutshell-graphql-types';

import WF_FORM_FRAGMENT from '../graphql/fragments/wf-form-fragment.graphql';
import CONNECTED_FORM_UNIGNORE from '../graphql/mutations/connected-form-unignore.graphql';

export function useUnignoreForm(): (arg1: ConnectedFormUnignoreInput) => Promise<any> {
    const [unignoreForm] = useMutation<
        ConnectedFormUnignoreMutation,
        ConnectedFormUnignoreMutationVariables
    >(CONNECTED_FORM_UNIGNORE);

    return (input: ConnectedFormUnignoreInput) => {
        return unignoreForm({
            variables: {input},
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment.
                const formFragment = proxy.readFragment({
                    id: input.wfFormId,
                    fragmentName: 'WfFormFragment',
                    fragment: WF_FORM_FRAGMENT,
                });

                if (formFragment) {
                    const updatedForm =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.connectedFormUnignore &&
                        mutationResults.data.connectedFormUnignore.connectedForm;

                    if (!updatedForm) return;

                    proxy.writeFragment({
                        id: input.wfFormId,
                        fragmentName: 'WfFormFragment',
                        fragment: WF_FORM_FRAGMENT,
                        data: updatedForm,
                    });
                }
            },
        });
    };
}
